const defaultFields = [
  {
    key: 'commands',
    label: '',
    tdClass: 'grid-commands-width-1',
  },
  {
    key: 'id',
    label: 'id',
    sortable: true,
	 },
  {
    key: 'guid',
    label: 'guid',
    sortable: true,
	 },
  {
    key: 'number',
    label: 'number',
    sortable: true,
	 },
  {
    key: 'name',
    label: 'name',
    sortable: true,
	 },
  {
    key: 'createdByUserId',
    label: 'createdByUserId',
    sortable: true,
	 },
  {
    key: 'modifiedByUserId',
    label: 'modifiedByUserId',
    sortable: true,
	 },
  {
    key: 'dateCreated',
    label: 'dateCreated',
    sortable: true,
	 },
  {
    key: 'dateModified',
    label: 'dateModified',
    sortable: true,
	 },
  {
    key: 'active',
    label: 'active',
    sortable: true,
	 },
];

export default defaultFields;
